<h1 mat-dialog-title>{{tituloDialog}}</h1>
<form [formGroup]="form">
  <div mat-dialog-content class="air-theme">

    <div fxLayout="row" class="flexwrap">

      <div fxFlex="100%">
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'protocolEdit.dialog.equipment.type.label' | translate }}</mat-label>
          <mat-select required name="idType" [(ngModel)]="data.equipment.idType">
            @for (item of equipmentTypes; track item) {
              <mat-option [value]="item.id">
                {{ 'equipmentType.' + item.translation | translate }}
              </mat-option>
            }
          </mat-select>
          <mat-error>
            {{ 'protocolEdit.dialog.equipment.type.error' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      <div fxFlex="50" fxFlex.lt-md="100%">
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'protocolEdit.dialog.equipment.maker.label' | translate }}</mat-label>
          <input matInput
            name="maker" [(ngModel)]="data.equipment.maker">
          <mat-error>
            {{ 'protocolEdit.dialog.equipment.maker.error' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      <div fxFlex="50" fxFlex.lt-md="100%">
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'protocolEdit.dialog.equipment.model.label' | translate }}</mat-label>
          <input matInput name="model" [(ngModel)]="data.equipment.model">
          <mat-error>
            {{ 'protocolEdit.dialog.equipment.model.error' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      <div fxFlex="50" fxFlex.lt-md="100%">
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'protocolEdit.dialog.equipment.serialNum.label' | translate }}</mat-label>
          <input matInput name="serialNum" [(ngModel)]="data.equipment.serialNum">
          <mat-error>
            {{ 'protocolEdit.dialog.equipment.serialNum.error' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

    </div>

  </div>
  <div mat-dialog-actions class="air-theme">
    <div fxFlex></div>
    <button mat-raised-button color="primary" (click)="onOkClick()">{{ 'button.save' | translate }}</button>
    <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
  </div>

</form>